import * as React from 'react'

function SvgPlayerChromecast(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M20.182 4H3.818C2.818 4 2 4.8 2 5.778v2.666h1.818V5.778h16.364v12.444h-6.364V20h6.364c1 0 1.818-.8 1.818-1.778V5.778C22 4.8 21.182 4 20.182 4zM2 17.333V20h2.727c0-1.476-1.218-2.667-2.727-2.667zm0-3.555v1.778c2.51 0 4.545 1.99 4.545 4.444h1.819c0-3.44-2.846-6.222-6.364-6.222zm0-3.556V12c4.518 0 8.182 3.582 8.182 8H12c0-5.404-4.482-9.778-10-9.778z" />
    </svg>
  )
}

export default SvgPlayerChromecast
